var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-wrapper welcome"},[_c(_vm.component,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }